import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/600.css'
import '@fontsource/roboto/700.css'
import '@fontsource/roboto-mono/600.css'
import '@fontsource/roboto-mono/700.css'
import type { CSSProperties } from 'react'
import type { ThemeOptions } from '@mui/material'

/**
 * Overrides MUI's TS-module declaration for the sake of adding
 * 2 custom variants: code1 and code2.
 */
declare module '@mui/material/styles' {
    interface TypographyVariants {
        code1: CSSProperties
        code2: CSSProperties
    }

    // allows configuration using `createTheme()`
    interface TypographyVariantsOptions {
        code1?: CSSProperties
        code2?: CSSProperties
    }
}

// updates the Typography's variant prop options
declare module '@mui/material/Typography' {
    interface TypographyPropsVariantOverrides {
        code1: true
        code2: true
    }
}

export const typography: ThemeOptions['typography'] = {
    h1: {
        fontSize: '4.5rem',
        lineHeight: '5.625rem',
        letterSpacing: '-0.02em',
    },
    h2: {
        fontSize: '3.75rem',
        lineHeight: '4.5rem',
        letterSpacing: '-0.02em',
    },
    h3: {
        fontSize: '3rem',
        lineHeight: '3.75rem',
        letterSpacing: '-0.02em',
    },
    h4: {
        fontSize: '2.25rem',
        lineHeight: '2.75rem',
        letterSpacing: '-0.02em',
    },
    h5: {
        fontSize: '1.875rem',
        lineHeight: '2.375rem',
        letterSpacing: 0,
    },
    h6: {
        fontSize: '1.5rem',
        lineHeight: '2rem',
        letterSpacing: 0,
    },
    subtitle1: {
        fontSize: '1.25rem',
        lineHeight: '1.875rem',
        letterSpacing: 0,
    },
    subtitle2: {
        fontSize: '1.125rem',
        lineHeight: '1.75rem',
        letterSpacing: 0,
    },
    body1: {
        fontSize: '1rem', // 16px
        lineHeight: '1.5rem',
        letterSpacing: 0,
    },
    body2: {
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        letterSpacing: 0,
    },
    caption: {
        fontSize: '0.75rem',
        lineHeight: '1.125rem',
        letterSpacing: 0,
    },
    code1: {
        fontFamily: "'Roboto Mono', Consolas, Menlo, monospace",
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
    },
    code2: {
        fontFamily: "'Roboto Mono', Consolas, Menlo, monospace",
        fontSize: '0.75rem',
        lineHeight: '1.125rem',
    },
}
